import React, { useState, useEffect, useMemo } from 'react'
import { defer, Outlet, redirect, useLocation } from 'react-router-dom'
// import { MpHeader } from '../shared/organism/MpHeader'
import {
  fetchBrokers,
  fetchPeopleFinderProfile,
} from '@meprism/shared/src/redux/peopleFinder/PeopleFinderSlice'
import message from '@meprism/shared/src/assets/icons/messenger.png'
import { useInboxSocket } from '../../utils/hooks/useInboxSocket'
import { persistor, store } from '../../redux/store'
import { FetchProfile, selectProfile } from '@meprism/shared/src/redux/profile/ProfileSlice'
import { fetchAlerts } from '@meprism/shared/src/redux/alert/AlertSlice'
import {
  checkPendingOffers,
  fetchGrants,
  fetchProducts,
} from '../../redux/product/ProductSlice'
import { Logger } from '@meprism/app-utils'
import { Box, useMediaQuery } from '@mui/material'
import { theme } from '../../theme/DashboardTheme'
import AuthLetterRequiredModal from '../shared/molecule/AuthLetterRequiredModal'
import StreetAdressRequireModal from '../shared/molecule/StreetAdressRequireModal'
import PhoneNumberRequiredModal from '../shared/molecule/PhoneNumberRequiredModal'
import CompleteFamilyPlan from '../shared/molecule/CompleteFamilyPlanModal'
import { useAppSelector } from '../../redux/storeExports'
import {fetchFamilyStatus, selectActiveGrant, selectFamilyStatus} from '@meprism/shared/src/redux/product/ProductSlice'
import { setFamilyPromptCookie } from '../../utils/helpers'
// import { MpHeader } from '../shared/organism/MpHeader'
import Cookies from 'universal-cookie'
// 3 hours in milliseconds
export const timeElapsed: number = 3 * 60 * 60 * 1000

enum ModalType {
  AUTH = 'auth',
  STREET = 'street',
  PHONE = 'phone',
  FAM = 'fam'
}

export const mainLayoutLoader = async () => {
  // Wait for persist rehydration
  persistor.persist()
  if (!persistor.getState().bootstrapped) {
    await new Promise((resolve) => {
      const unsubscribe = persistor.subscribe(() => {
        if (persistor.getState().bootstrapped) {
          unsubscribe();
          resolve(true);
        }
      });
    });
  }
  const state = store.getState();
  const previousFetchTime = state.peopleFinder.previousFetchTime;
  const now = new Date().getTime();
  try {
    store.dispatch(fetchAlerts())
    const grants = await store.dispatch(fetchGrants()).unwrap()
    store.dispatch(fetchProducts())
    store.dispatch(checkPendingOffers())
    store.dispatch(fetchFamilyStatus())
    const peopleFinderProfile = store
      .dispatch(fetchPeopleFinderProfile())
      .unwrap()
    // Check if 3 hours have passed since last broker fetch
    const brokerList = !previousFetchTime || (now - previousFetchTime >= timeElapsed)
      ? await store.dispatch(fetchBrokers())
      : state.peopleFinder.brokers
    const profile = await store.dispatch(FetchProfile()).unwrap()
    return defer({ 
      peopleFinderProfile, 
      brokerList, 
      profile,
      grants 
    })
  } catch (error) {
    Logger.error(`Error fetching : ${error} ${error?.message}`)
    return redirect('/onboarding')
  }
}

export const MainLayout = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [activeModal, setActiveModal] = useState<ModalType | null>(null)
  const grants = useAppSelector(selectActiveGrant)
  const profile= useAppSelector(selectProfile)
  const location = useLocation()
  const familyPlan = useAppSelector(selectFamilyStatus)
  const shouldShowFamilyPlanModal = grants && grants.sku.includes('fam') && !familyPlan?.email && location.pathname !== '/subscribe/success'
  const cookie = useMemo(() => new Cookies(), []);

  useEffect(()=>{
    if(shouldShowFamilyPlanModal){
      setFamilyPromptCookie()
    }
  },[grants, familyPlan, shouldShowFamilyPlanModal])

  const shouldHideModal = location.pathname === '/subscribe/success' || location.pathname === '/dashboard/profile'
  useEffect(() => {
    if (grants) {
      const hasEmptyStreet = profile?.address?.some(addr => !addr?.street1?.trim())
      const hasEmptyPhoneNumber = profile?.phones?.length === 0
      // Check if any address has an empty street1
      if (hasEmptyStreet) {
        if (!shouldHideModal) {
          setTimeout(() => {
            setActiveModal(ModalType.STREET)
          }, 300) 
        } 
        }

      // Check if phone number is missing
      else if (hasEmptyPhoneNumber) {
        if (!shouldHideModal) {
          setTimeout(() => {
            setActiveModal(ModalType.PHONE)
          }, 300) 
        } 
      }
        // Then check for auth letter if street address exists
      else if (!shouldHideModal && !profile?.auth_letter_s3_key) {
        setTimeout(() => {
          setActiveModal(ModalType.AUTH)
        }, 1500)
      }

      else if (shouldShowFamilyPlanModal) {
        const famPlanCookie = cookie.get('PromptForFamilyPlan')
        if(famPlanCookie && famPlanCookie==='true'){
          setTimeout(() => {
            setActiveModal(ModalType.FAM)
          }, 1500)
        }
      }
    }
  },[grants, profile, shouldHideModal, shouldShowFamilyPlanModal, cookie])

  useInboxSocket({ fqdn: process.env.REACT_APP_API_FQDN as string })
  const stylesbottom = {
    bottomRightIcon: {
      position: 'fixed',
      bottom: 20,
      zIndex: 9999,
      right: 20
    },
  }
  return (
    <>
      {/* <MpHeader /> */}

      <Outlet />
      {!isMobile && <Box sx={{ ...stylesbottom.bottomRightIcon, cursor: 'pointer' }}>
        <img
          src={message}
          id={'intercom-launcher'}
          alt="Description of the image"
          style={{
            maxWidth: '50px',
            maxHeight: '50px',
            marginRight: '10px',
          }}
        /></Box>}
      <StreetAdressRequireModal 
        open={activeModal === ModalType.STREET}
        setOpen={() => setActiveModal(null)}
      />
      <PhoneNumberRequiredModal 
        open={activeModal === ModalType.PHONE}
        setOpen={() => setActiveModal(null)}
      />
      <AuthLetterRequiredModal 
        open={activeModal === ModalType.AUTH}
        setOpen={() => setActiveModal(null)}
      />
      <CompleteFamilyPlan
        open={activeModal === ModalType.FAM}
        setOpen={() => setActiveModal(null)}
      />
    </>
  )
}
